<template>
  <div class="social-responsibility">
    <div class="container">
      <!-- 新增的固定布局 view -->
      <div class="top-fixed-view">
        <img class="left-image" :src=leftImage alt="Left Image" @click="clickBack" />
        <div class="button-container" @mouseenter="showAboutList" @mouseleave="hideAboutList">
          <button class="about-us-button" @click="toggleAboutList" v-if="!isMobile">
            <span class="button-text">关于我们</span>
          </button>

          <!-- 透明间隔 -->
          <div class="nav-gap"></div>
          <!-- 列表 -->
          <div class="about-list" v-show="isListVisible">
            <ul>
              <li v-for="(item, index) in aboutItems" :key="index" @click="handleItemClick(index)"
                :class="{ active: selectedIndex === index }">
                {{ item.text }}
              </li>
            </ul>
          </div>
        </div>

      </div>

      <div class="social-title">{{ this.message.title }}</div>
      <div class="social-date">
        <!-- 杭州心田花开 2019-09-09 -->
        {{ this.message.created_at }}
      </div>
      <div class="social-con container ql-editor" v-html="this.message.content">
        {{ this.message.content }}
      </div>
    </div>

    <div v-if="!isMobile" class="botton-view">
      <div class="top-section">
        <div class="left-part">
          <!-- 左边的内容 -->
          <img class="left-image-bottom" :src="require('../../assets/images/homeV2/logoV2.png')" alt="Company Image" />
          <div class="text-row">
            <span class="left-text" @click="handleItemClick(0)">公司简介</span>
            <span class="separator-line"></span>
            <span class="left-text" @click="handleItemClick(1)">教学模式</span>
            <span class="separator-line"></span>
            <span class="left-text" @click="handleItemClick(2)">企业愿景</span>
            <span class="separator-line"></span>
            <span class="left-text" @click="handleItemClick(3)">发展历程</span>
            <span class="separator-line"></span>
            <span class="left-text" @click="handleItemClick(4)">社会责任</span>
            <span class="separator-line"></span>
            <span class="left-text" @click="handleItemClick(5)">人才招聘</span>
          </div>
        </div>
        <div class="separator"></div> <!-- 竖线 -->
        <div class="right-part">
          <!-- 右边的内容 -->
          <div class="right-content">
            <h2 class="right-title">加入我们</h2>
            <p class="right-subtitle">扫描下方二维码，投递简历，了解更多招聘信息</p>
            <div class="qr-code-container">
              <div class="qr-item">
                <img class="qr-code" :src="require('../../assets/images/homeV2/zpQRCodeV2.png')" alt="QR Code 1" />
                <span class="qr-text">心田花开招聘网</span>
              </div>
              <div class="qr-item">
                <img class="qr-code" :src="require('../../assets/images/homeV2/gzhQRCodeV2.png')" alt="QR Code 2" />
                <span class="qr-text">心田花开招聘公众号</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-section">
        <p>蜀ICP备2024069709号-1</p>
        <p>Copyright © 成都心田花开教育咨询有限公司 2016 - 2024. All right reserved</p>
      </div>
    </div>

    <!-- 移动端布局 -->
    <div v-else class="botton-view-mobile">
      <img class="top-image" :src="require('../../assets/images/homeV2/logoV2.png')" alt="Top Image" />
      <div class="separator-line-mobile"></div>
      <h2 class="mobile-title">加入我们</h2>
      <p class="mobile-subtitle">扫描下方二维码，投递简历，了解更多招聘信息</p>
      <div class="mobile-qr-code-container">
        <div class="mobile-qr-item">
          <img class="mobile-qr-code" :src="require('../../assets/images/homeV2/zpQRCodeV2.png')" alt="QR Code 1" />
          <span class="mobile-qr-text">心田花开招聘网</span>
        </div>
        <div class="mobile-qr-item">
          <img class="mobile-qr-code" :src="require('../../assets/images/homeV2/gzhQRCodeV2.png')" alt="QR Code 2" />
          <span class="mobile-qr-text">心田花开招聘公众号</span>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import { detailDuty } from "@/libs/api"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"

export default {
  data () {
    return {
      isMobile: window.innerWidth <= 768,
      leftImage: window.innerWidth <= 768 ? require('../../assets/images/homeV2/backV2.png') : require('../../assets/images/homeV2/logoV2.png'),
      id: "",
      message: "",
      isListVisible: false,
      selectedIndex: null, // 当前选中的 item
      aboutItems: [
        { text: "公司简介" },
        { text: "教学模式" },
        { text: "企业愿景" },
        { text: "发展历程" },
        { text: "社会责任" },
        { text: "人才招聘" }
      ]
    }
  },
  components: {

  },
  created () {
    // if (this.isMobile) {
    this.id = this.$route.query.id
    // } else {
    //   // 取到路由带过来的参数
    //   this.id = this.$route.params.id;
    // }

    this.getMsg()
  },

  mounted () {
    // 页面加载后定位到顶部
    window.scrollTo(0, 0)
  },

  methods: {

    clickBack () {
      if (this.isMobile) {
        console.log('back')
        this.$router.back()
      }
    },

    toggleAboutList () {
      this.isListVisible = !this.isListVisible
    },

    showAboutList () {
      if (this.isMobile === false) {
        this.isListVisible = true
      }

    },

    hideAboutList () {
      if (this.isMobile === false) {
        this.isListVisible = false
      }

    },

    handleItemClick (index) {
      this.selectedIndex = index // 更新选中的 index


      if (index === 5) {
        this.isListVisible = false
        // 打开新窗口
        window.open("https://xintianhuakai1.zhiye.com", "_blank")
      } else {
        this.$router.push({
          path: '/',
          query: { index: index }
        })
      }
    },

    getMsg () {
      detailDuty({ id: this.$route.query.id }).then(res => {
        console.log("社会责任详情页:", res)
        this.message = res.data
      })
    }
  }
}
</script>
<style lang="less">
.social-responsibility {
  // height: 100%;
  width: 100%;


  &>div {
    background: rgba(255, 255, 255, 1);
  }

  .social-title {
    padding-top: 160px;
    text-align: center;
    font-size: 36px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: bold;
    line-height: 61px;
    color: rgba(51, 51, 51, 1);
  }

  .social-date {
    text-align: center;
    margin: 32px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    height: 70px;
    line-height: 48px;
    color: rgba(112, 112, 112, 1);
    border-bottom: 1px solid rgba(235, 235, 235, 1);
    margin-left: 252px;
    margin-right: 248px;
  }

  .social-con {
    min-height: 300px;
    margin-left: 252px;
    margin-right: 248px;

    img {
      width: 100%;
    }

    p {
      font-size: 16px;
      font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial,
        sans-serif;
      font-weight: 400;
      line-height: 50px;
      color: rgba(102, 102, 102, 1);
    }

    .first-p {
      margin: 64px 80px;
    }

    .imgs {
      margin-right: 0px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      span {
        font-size: 18px;
        font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial,
          sans-serif;
        font-weight: 500;
        line-height: 31px;
        color: rgba(51, 51, 51, 1);
        display: block;
      }
    }

    font-size: 16px;
    font-family: "PingFang SC",
    "Microsoft YaHei",
    "微软雅黑",
    Arial,
    sans-serif;
    font-weight: 400;
    line-height: 27px;
    color: rgba(102, 102, 102, 1);
  }

  .foot {
    width: 100%;
    height: 365px;
  }

  /* 顶部固定布局 */
  .top-fixed-view {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100px;
    background-color: white;
    border-radius: 0px;
    /* 高度的一半，产生圆角 */
    z-index: 10;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }


  .button-container {
    position: relative;
  }

  .nav-gap {
    height: 41px;
    background-color: transparent;
    // background-color: red;
  }

  /* 左侧图片 */
  .left-image {
    height: 60px;
    width: auto;
    margin-left: 248px;
  }

  /* 按钮 */
  .about-us-button {
    width: 124px;
    height: 50px;
    border: 1px solid #262626;
    border-radius: 25px;
    /* 椭圆形效果 */
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 248px;
    margin-top: 41px
  }

  .button-text {
    color: #262626;
    font-size: 18px;
    font-family: "PingFang SC-Regular";
  }

  /* 列表的样式 */
  .about-list {
    position: absolute;
    right: 190px;
    top: 125px;
    width: 220px;
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    border-radius: 24px;
    /* 设置8px的圆角 */
  }

  .about-list ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .about-list li {
    height: 68px;
    line-height: 68px;
    font-size: 18px;
    font-family: "PingFang SC-Regular", sans-serif;
    color: #595959;
    text-align: center;
    cursor: pointer;
    border-bottom: 0.5px solid #eaeaea;
    /* 每个 item 之间的分割线 */
    transition: color 0.3s;
    /* 添加过渡效果 */
  }

  /* 最后一个item不要显示底部的分割线 */
  .about-list li:last-child {
    border-bottom: none;
  }

  .about-list li:hover {
    background-color: #f5f5f5;
  }

  /* 鼠标悬浮时，第一个和最后一个item有圆角 */
.about-list li:first-child:hover {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}

.about-list li:last-child:hover {
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
}

  /* 点击后的选中效果 */
  .about-list li.active {
    color: #05BD6F;
    /* 选中项文字变成绿色 */
  }

  .botton-view {
    width: 100%;
    aspect-ratio: 1920 / 570;
    background-color: #F6F6F6;
    display: flex;
    flex-direction: column;
  }

  .top-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 58px;
  }

  .left-part {
    flex: 1;
    padding-left: 208px;
  }

  .left-image-bottom {
    margin-bottom: 68px;
  }

  .text-row {
    display: flex;
    align-items: center;
  }

  .left-text {
    font-size: 18px;
    font-family: "PingFang SC-Regular", sans-serif;
    color: rgba(38, 38, 38, 0.85);
    cursor: pointer;
  }

  .left-text:hover {
    color: rgba(5, 189, 111, 0.85);
  }

  .separator-line {
    display: inline-block;
    width: 1px;
    height: 14px;
    background-color: #D8D8D8;
    margin: 0 20px;
  }

  .separator {
    width: 1px;
    height: 180px;
    background-color: #D8D8D8;
    margin-left: 119px;
    margin-top: 55px;
  }

  .right-part {
    flex: 1;
    display: flex;
    justify-content: center;
    /* 水平居中 */
    align-items: center;
    /* 垂直居中 */
    flex-direction: column;
  }

  .right-content {
    text-align: center;
  }

  .right-title {
    font-size: 18px;
    font-family: "PingFang SC-Medium", sans-serif;
    color: #262626;
    margin-bottom: 12px;
  }

  .right-subtitle {
    font-size: 14px;
    font-family: "PingFang SC-Regular", sans-serif;
    color: #8C8C8C;
    margin-bottom: 40px;
  }

  .qr-code-container {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 12px;
  }

  .qr-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .qr-code {
    width: 160px;
    height: 160px;
  }

  .qr-text {
    font-size: 14px;
    font-family: "PingFang SC-Regular", sans-serif;
    color: #595959;
    margin-top: 12px;
    /* 距离二维码12px */
  }


  .bottom-section {
    text-align: center;
    font-size: 14px;
    font-family: "PingFang SC-Regular", sans-serif;
    color: #8C8C8C;
    line-height: 24px;
    margin-top: 90px;

  }

  .bottom-section p {
    margin: 0;
    display: inline-block;
    margin-right: 40px;
    /* 两段文字间距40px */
  }

  .bottom-section p:last-child {
    margin-right: 0;
  }

  .botton-view-mobile {
    width: 100%;
    aspect-ratio: 375 / 288;
    background-color: #F6F6F6;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 28px;
  }

  .top-image {
    height: 27px;
    width: auto;
    object-fit: cover;
  }

  .separator-line-mobile {
    width: calc(100% - 32px);
    /* 左右16px的距离 */
    height: 1px;
    background-color: #EDEDED;
    margin: 10px 0;
  }

  .mobile-title {
    font-size: 12px;
    font-family: "PingFang SC-Medium", sans-serif;
    color: #262626;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 0px;
  }

  .mobile-subtitle {
    font-size: 10px;
    font-family: "PingFang SC-Regular", sans-serif;
    color: #595959;
    text-align: center;
    margin-top: 4px;
  }

  .mobile-qr-code-container {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 10px;
  }

  .mobile-qr-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .mobile-qr-code {
    width: 100px;
    height: 100px;
  }

  .mobile-qr-text {
    font-size: 10px;
    font-family: "PingFang SC-Regular", sans-serif;
    color: #595959;
    margin-top: 6px;
    /* 图片和文字之间的间距 */
  }


}

/* 移动设备适配 */
.mobile {
  .top-fixed-view {
    position: fixed;
    left: 0;
    right: 0;
    height: 44px;
    top: 0;
    border-radius: 0;
    /* 移动设备上无圆角 */
    padding: 0;
  }

  .left-image {
    height: 22px;
    width: auto;
    margin-left: 16px;
    /* 移动端左侧间距缩小 */
  }

  .about-us-button {
    width: 20px;
    height: 20px;
    border: none;
    background: url('../../assets/images/homeV2/menueV2.png') no-repeat center;
    background-size: contain;
    margin-right: 16px
  }

  .button-text {
    display: none;
    /* 移动端隐藏文字 */
  }

  .about-list {
    width: 100%;
    /* 列表宽度为100% */
    top: 44px;
    /* 列表紧贴顶部 View */
    right: 0;
    /* 右侧与屏幕边缘对齐 */
    border-radius: 0;
    /* 移动端不需要圆角 */
  }

  .about-list li {
    height: 42px;
    /* 每个 item 的高度 */
    line-height: 42px;
    /* 使文本在高度内垂直居中 */
    font-size: 12px;
    /* 字体大小 */
  }

  .social-title {
    padding-top: 74px;
    font-size: 16px;
  }

  .social-date {
    margin-left: 12px;
    margin-right: 12px;
    height: 30px;
    margin: 0;
    font-size: 11px;
    line-height: 0px;
  }

  .social-con {
    margin-left: 0px;
    margin-right: 0px;

    p {
      font-size: 10px;
      line-height: 25px;

    }
  }
}
</style>